import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { Icon } from '../../Icon/Icon';
import { VerticalDivider } from '../../VerticalDivider/VerticalDivider';
import { FlexContainer } from '../../layout/FlexContainer';
export const DIALOG_DRAG_HANDLE_CLASS = 'dialog-drag-handle';
const StyledDragGrip = styled('div', {
    cursor: 'grab',
    userSelect: 'none',
    opacity: 0.5,
    ':hover': {
        opacity: 0.8,
    },
    ':active': {
        cursor: 'grabbing',
        opacity: 1,
    },
});
const StyledCloseButton = styled('div', {
    cursor: 'pointer',
    opacity: 0.5,
    ':hover': {
        opacity: 0.8,
    },
});
export const DialogTitleRightControls = ({ draggable, onClose, titleRightElement, }) => {
    const hasDragOrClose = draggable || !!onClose;
    if (!titleRightElement && !hasDragOrClose)
        return null;
    const maybeDragGrip = draggable ? (_jsx(StyledDragGrip, { className: DIALOG_DRAG_HANDLE_CLASS, children: _jsx(Icon, { name: 'DragIndicator', size: 'medium', color: 'grey' }) })) : null;
    const maybeCloseIcon = onClose ? (_jsx(StyledCloseButton, { onClick: onClose, children: _jsx(Icon, { name: 'Close', size: 'medium', color: 'grey' }) })) : null;
    const hasDivider = titleRightElement && hasDragOrClose;
    const maybeDivider = hasDivider ? _jsx(VerticalDivider, {}) : null;
    return (_jsxs(FlexContainer, { direction: 'row', verticalAlign: 'top', gap: true, children: [titleRightElement, maybeDivider, maybeDragGrip, maybeCloseIcon] }));
};
